import React, { useContext, useState, useEffect } from "react";
import AuthContext from "./AuthContext";
import authService from "../../../services/auth.service";
import { AUTH_LOGOUT_EVENT } from "../../../services/api";

const AuthState = (props) => {
  const [currentUser, setcurrentUser] = useState(undefined);
  const [userExist, setuserExist] = useState(false);

  useEffect(() => {
    const user = authService.getCurrentUser();
    if (user) {
      setcurrentUser(user);
      setuserExist(true);
    } else {
      setcurrentUser(null);
      setuserExist(false);
    }
  }, []);

  useEffect(() => {
    const handleLogout = () => {
      setcurrentUser(null);
      setuserExist(false);
    };

    window.addEventListener(AUTH_LOGOUT_EVENT, handleLogout);
    return () => window.removeEventListener(AUTH_LOGOUT_EVENT, handleLogout);
  }, []);

  const login = async (phone, password) => {
    const user = await authService.login(phone, password);
    setcurrentUser(user);
    setuserExist(true);
    return user;
  };

  const signup = async (userData) => {
    const user = await authService.signup(userData);
    setcurrentUser(user);
    setuserExist(true);
    return user;
  };

  const resetPassword = async (phone, otp, newPassword) => {
    const user = await authService.resetPassword(phone, otp, newPassword);
    setcurrentUser(user);
    setuserExist(true);
    return user;
  };

  const logout = async () => {
    await authService.logout();
    setcurrentUser(null);
    setuserExist(false);
  };

  const value = { currentUser, userExist, login, signup, resetPassword, logout };

  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
};

export function useAuth() {
  return useContext(AuthContext);
}

export default AuthState;
